export default [
	{'name':'Açores', 'continent':'África','code':''},
	{'name':'Acrotiri e Deceleia', 'continent':'Europa','code':''},
	{'name':'Afeganistão', 'continent':'Ásia','code':'AFG'},
	{'name':'África do Sul', 'continent':'África','code':'ZA'},
	{'name':'Albânia', 'continent':'Europa','code':'AL'},
	{'name':'Alemanha', 'continent':'Europa','code':'DE'},
	{'name':'Andorra', 'continent':'Europa','code':''},
	{'name':'Angola', 'continent':'África','code':'AO'},
	{'name':'Anguila', 'continent':'América','code':''},
	{'name':'Antártida', 'continent':'Antártida','code':''},
	{'name':'Antígua e Barbuda', 'continent':'América','code':''},
	{'name':'Antilhas Holandesas', 'continent':'América','code':''},
	{'name':'Arábia Saudita', 'continent':'Ásia','code':'SA.'},
	{'name':'Argélia', 'continent':'África','code':'DZ'},
	{'name':'Argentina', 'continent':'América','code':'ARG'},
	{'name':'Armênia', 'continent':'Europa','code':'AM'},
	{'name':'Aruba', 'continent':'América','code':''},
	{'name':'Austrália', 'continent':'Oceania','code':'AUS'},
	{'name':'Áustria', 'continent':'Europa','code':'AT'},
	{'name':'Azerbaijão', 'continent':'Europa','code':'AZ'},
	{'name':'Bahamas', 'continent':'América','code':''},
	{'name':'Bangladesh', 'continent':'Ásia','code':'BGD'},
	{'name':'Barbados', 'continent':'América','code':''},
	{'name':'Barém', 'continent':'Ásia','code':'BHR'},
	{'name':'Bélgica', 'continent':'Europa','code':'BE'},
	{'name':'Belize', 'continent':'América','code':''},
	{'name':'Benim', 'continent':'África','code':'BEN.'},
	{'name':'Bermudas', 'continent':'América','code':''},
	{'name':'Bielorrússia', 'continent':'Europa','code':'BLR'},
	{'name':'Bolívia', 'continent':'América','code':'BOL'},
	{'name':'Bósnia e Herzegovina', 'continent':'Europa','code':'BA'},
	{'name':'Botsuana', 'continent':'África','code':'BW'},
	{'name':'Brunei', 'continent':'Ásia','code':'BRN'},
	{'name':'Bulgária', 'continent':'Europa','code':'BG'},
	{'name':'Burquina Faso', 'continent':'África','code':'BF'},
	{'name':'Burundi', 'continent':'África','code':'BDI'},
	{'name':'Butão', 'continent':'Ásia','code':'BT'},
	{'name':'Cabo Verde', 'continent':'África','code':''},
	{'name':'Camarões', 'continent':'África','code':'CMR'},
	{'name':'Camboja', 'continent':'Ásia','code':'KHM'},
	{'name':'Canadá', 'continent':'América','code':'CA'},
	{'name':'Canárias', 'continent':'África','code':''},
	{'name':'Catar', 'continent':'Ásia','code':'QA'},
	{'name':'Cazaquistão', 'continent':'Ásia','code':'KZ'},
	{'name':'Chade', 'continent':'África','code':'TD'},
	{'name':'Chile', 'continent':'América','code':'CL'},
	{'name':'China', 'continent':'Ásia','code':'CHN'},
	{'name':'Chipre', 'continent':'Europa','code':'CY'},
	{'name':'Colômbia', 'continent':'América','code':'CO'},
	{'name':'Comores', 'continent':'África','code':''},
	{'name':'Coreia do Norte', 'continent':'Ásia','code':'KP'},
	{'name':'Coreia do Sul', 'continent':'Ásia','code':'KR'},
	{'name':'Costa do Marfim', 'continent':'África','code':'CI'},
	{'name':'Costa Rica', 'continent':'América','code':'CR'},
	{'name':'Croácia', 'continent':'Europa','code':'HRV'},
	{'name':'Cuba', 'continent':'América','code':'CU'},
	{'name':'Curaçao', 'continent':'América','code':''},
	{'name':'Dinamarca', 'continent':'Europa','code':'DNK'},
	{'name':'Djibuti', 'continent':'África','code':'DJ'},
	{'name':'Domínica', 'continent':'América','code':''},
	{'name':'Egito', 'continent':'África','code':'EGY'},
	{'name':'El Salvador', 'continent':'América','code':'SLV'},
	{'name':'Emirados Árabes Unidos', 'continent':'Ásia','code':'ARE'},
	{'name':'Equador', 'continent':'América','code':'EC'},
	{'name':'Eritreia', 'continent':'África','code':'ER'},
	{'name':'Escócia', 'continent':'Europa','code':''},
	{'name':'Eslováquia', 'continent':'Europa','code':'SK'},
	{'name':'Eslovênia', 'continent':'Europa','code':'SI'},
	{'name':'Espanha', 'continent':'Europa','code':'ES'},
	{'name':'Estados Unidos', 'continent':'América','code':'US'},
	{'name':'Estônia', 'continent':'Europa','code':'EE'},
	{'name':'Etiópia', 'continent':'África','code':'ETH'},
	{'name':'Faroé', 'continent':'Europa','code':''},
	{'name':'Fiji', 'continent':'Oceania','code':''},
	{'name':'Filipinas', 'continent':'Ásia','code':'PHL'},
	{'name':'Finlândia', 'continent':'Europa','code':'FI'},
	{'name':'França', 'continent':'Europa','code':'FRA'},
	{'name':'Gabão', 'continent':'África','code':'GA'},
	{'name':'Gâmbia', 'continent':'África','code':'GM'},
	{'name':'Gana', 'continent':'África','code':'GH'},
	{'name':'Geórgia', 'continent':'Europa','code':'GEO'},
	{'name':'Geórgia do Sul e Sandwich do Sul', 'continent':'América','code':''},
	{'name':'Gibraltar', 'continent':'Europa','code':''},
	{'name':'Granada', 'continent':'América','code':''},
	{'name':'Grécia', 'continent':'Europa','code':'GRC'},
	{'name':'Groenlândia', 'continent':'América','code':'GL'},
	{'name':'Guadalupe', 'continent':'América','code':''},
	{'name':'Guam', 'continent':'Oceania','code':''},
	{'name':'Guatemala', 'continent':'América','code':'GT'},
	{'name':'Guernsey', 'continent':'Europa','code':''},
	{'name':'Guiana', 'continent':'América','code':'GY'},
	{'name':'Guiana Francesa', 'continent':'América','code':'GF'},
	{'name':'Guiné', 'continent':'África','code':'GN'},
	{'name':'Guiné Bissau', 'continent':'África','code':'GW'},
	{'name':'Guiné Equatorial', 'continent':'África','code':'GQ'},
	{'name':'Haiti', 'continent':'América','code':'HTI'},
	{'name':'Holanda (Países baixos)', 'continent':'Europa','code':'NL'},
	{'name':'Honduras', 'continent':'América','code':'HN'},
	{'name':'Hong Kong', 'continent':'Ásia','code':''},
	{'name':'Hungria', 'continent':'Europa','code':'HUN'},
	{'name':'Iêmen', 'continent':'Ásia','code':'YE'},
	{'name':'Ilha Bouvet', 'continent':'América','code':''},
	{'name':'Ilha da Madeira', 'continent':'África','code':''},
	{'name':'Ilha de Clipperton', 'continent':'Oceania','code':''},
	{'name':'Ilha de Man', 'continent':'Europa','code':''},
	{'name':'Ilha de Navassa', 'continent':'América','code':''},
	{'name':'Ilha do Natal', 'continent':'Oceania','code':''},
	{'name':'Ilha Jan Mayen', 'continent':'Europa','code':''},
	{'name':'Ilha Norfolk', 'continent':'Oceania','code':''},
	{'name':'Ilha Wake', 'continent':'Oceania','code':''},
	{'name':'Ilhas Ashmore e Cartier', 'continent':'Oceania','code':''},
	{'name':'Ilhas Caimão', 'continent':'América','code':''},
	{'name':'Ilhas Cocos', 'continent':'Oceania','code':''},
	{'name':'Ilhas Cook', 'continent':'Oceania','code':''},
	{'name':'Ilhas do mar de coral', 'continent':'Oceania','code':''},
	{'name':'Ilhas Falkland', 'continent':'América','code':''},
	{'name':'Ilhas Heard e McDonald', 'continent':'Oceania','code':''},
	{'name':'Ilhas Marshall', 'continent':'Oceania','code':''},
	{'name':'Ilhas Paracel', 'continent':'Ásia','code':''},
	{'name':'Ilhas Pitcairn', 'continent':'Oceania','code':''},
	{'name':'Ilhas Salomão', 'continent':'Oceania','code':''},
	{'name':'Ilhas Spratly', 'continent':'Ásia','code':''},
	{'name':'Ilhas Turcas e Caicos', 'continent':'América','code':''},
	{'name':'Ilhas Virgens Americanas', 'continent':'América','code':''},
	{'name':'Ilhas Virgens Britânicas', 'continent':'América','code':''},
	{'name':'Índia', 'continent':'Ásia','code':'IN'},
	{'name':'Indonésia', 'continent':'Ásia','code':'IDN'},
	{'name':'Inglaterra', 'continent':'Europa','code':''},
	{'name':'Irã', 'continent':'Ásia','code':'IR'},
	{'name':'Iraque', 'continent':'Ásia','code':'IRQ'},
	{'name':'Irlanda', 'continent':'Europa','code':'IE'},
	{'name':'Irlanda do norte', 'continent':'Europa','code':''},
	{'name':'Islândia', 'continent':'Europa','code':'ISL'},
	{'name':'Israel', 'continent':'Ásia','code':'IL'},
	{'name':'Itália', 'continent':'Europa','code':'ITA'},
	{'name':'Jamaica', 'continent':'América','code':'JAM'},
	{'name':'Japão', 'continent':'Ásia','code':'JPN'},
	{'name':'Jersey', 'continent':'Europa','code':''},
	{'name':'Jordânia', 'continent':'Ásia','code':'JO'},
	{'name':'Kosovo', 'continent':'Europa','code':''},
	{'name':'Kuwait', 'continent':'Ásia','code':'KW'},
	{'name':'Laos', 'continent':'Ásia','code':'LA'},
	{'name':'Lesoto', 'continent':'África','code':'LS'},
	{'name':'Letônia', 'continent':'Europa','code':'LV'},
	{'name':'Líbano', 'continent':'Ásia','code':'LB'},
	{'name':'Libéria', 'continent':'África','code':'LBR'},
	{'name':'Líbia', 'continent':'África','code':'LY'},
	{'name':'Liechtenstein', 'continent':'Europa','code':''},
	{'name':'Lituânia', 'continent':'Europa','code':'LT'},
	{'name':'Luxemburgo', 'continent':'Europa','code':''},
	{'name':'Macau', 'continent':'Ásia','code':''},
	{'name':'Macedônia', 'continent':'Europa','code':'MK'},
	{'name':'Madagascar', 'continent':'África','code':'MDG'},
	{'name':'Malásia', 'continent':'Ásia','code':'MY'},
	{'name':'Malawi', 'continent':'África','code':'MWI'},
	{'name':'Maldivas', 'continent':'Ásia','code':''},
	{'name':'Mali', 'continent':'África','code':'ML'},
	{'name':'Malta', 'continent':'Europa','code':''},
	{'name':'Marianas do Norte', 'continent':'Oceania','code':''},
	{'name':'Marrocos', 'continent':'África','code':'MAR'},
	{'name':'Martinica', 'continent':'América','code':''},
	{'name':'Maurício', 'continent':'África','code':''},
	{'name':'Mauritânia', 'continent':'África','code':'MR'},
	{'name':'Mayotte', 'continent':'África','code':''},
	{'name':'México', 'continent':'América','code':'MEX'},
	{'name':'Micronésia', 'continent':'Oceania','code':''},
	{'name':'Moçambique', 'continent':'África','code':'MZ'},
	{'name':'Moldávia', 'continent':'Europa','code':'MD'},
	{'name':'Mônaco', 'continent':'Europa','code':''},
	{'name':'Mongólia', 'continent':'Ásia','code':'MN'},
	{'name':'Monserrate', 'continent':'América','code':''},
	{'name':'Montenegro', 'continent':'Europa','code':'MNE'},
	{'name':'Myanmar', 'continent':'Ásia','code':'MMR'},
	{'name':'Namíbia', 'continent':'África','code':'NA'},
	{'name':'Nauru', 'continent':'Oceania','code':''},
	{'name':'Nepal', 'continent':'Ásia','code':'NPL'},
	{'name':'Nicarágua', 'continent':'América','code':'NI'},
	{'name':'Níger', 'continent':'África','code':'NE'},
	{'name':'Nigéria', 'continent':'África','code':'NGA'},
	{'name':'Niue', 'continent':'Oceania','code':''},
	{'name':'Noruega', 'continent':'Europa','code':'NOR'},
	{'name':'Nova Caledônia', 'continent':'Oceania','code':''},
	{'name':'Nova Zelândia', 'continent':'Oceania','code':'NZ'},
	{'name':'Omã', 'continent':'Ásia','code':'OM'},
	{'name':'País de Gales', 'continent':'Europa','code':''},
	{'name':'Palau', 'continent':'Oceania','code':''},
	{'name':'Palestina', 'continent':'Ásia','code':''},
	{'name':'Panamá', 'continent':'América','code':'PAN'},
	{'name':'Papua-Nova Guiné', 'continent':'Oceania','code':'PNG'},
	{'name':'Paquistão', 'continent':'Ásia','code':'PK'},
	{'name':'Paraguai', 'continent':'América','code':'PY'},
	{'name':'Peru', 'continent':'América','code':'PE'},
	{'name':'Polinésia Francesa', 'continent':'Oceania','code':''},
	{'name':'Polônia', 'continent':'Europa','code':'POL'},
	{'name':'Porto Rico', 'continent':'América','code':''},
	{'name':'Portugal', 'continent':'Europa','code':'PRT'},
	{'name':'Quênia', 'continent':'África','code':'KEN'},
	{'name':'Quirguizistão', 'continent':'Ásia','code':'KG'},
	{'name':'Quiribati', 'continent':'Oceania','code':''},
	{'name':'Reino Unido', 'continent':'Europa','code':'GBR'},
	{'name':'República Centro-Africana', 'continent':'África','code':'CF'},
	{'name':'República Checa', 'continent':'Europa','code':'CZE'},
	{'name':'República Democrática do Congo', 'continent':'África','code':'COD'},
	{'name':'República do Congo', 'continent':'África','code':'CG'},
	{'name':'República Dominicana', 'continent':'América','code':'DO'},
	{'name':'Romênia', 'continent':'Europa','code':'RO'},
	{'name':'Ruanda', 'continent':'África','code':'RWA'},
	{'name':'Rússia', 'continent':'Europa','code':'RUS'},
	{'name':'Saara Ocidental', 'continent':'África','code':''},
	{'name':'Samoa', 'continent':'Oceania','code':''},
	{'name':'Samoa Americana', 'continent':'Oceania','code':''},
	{'name':'Santa Helena', 'continent':'África','code':''},
	{'name':'Santa Lúcia', 'continent':'América','code':''},
	{'name':'São Cristóvão e Neves', 'continent':'América','code':''},
	{'name':'São Marinho', 'continent':'Europa','code':''},
	{'name':'São Pedro e Miquelon', 'continent':'América','code':''},
	{'name':'São Tomé e Príncipe', 'continent':'África','code':''},
	{'name':'São Vicente e Granadinas', 'continent':'América','code':''},
	{'name':'Seicheles', 'continent':'África','code':''},
	{'name':'Senegal', 'continent':'África','code':'SN'},
	{'name':'Serra Leoa', 'continent':'África','code':'SL'},
	{'name':'Sérvia', 'continent':'Europa','code':'RS'},
	{'name':'Singapura', 'continent':'Ásia','code':'SGP'},
	{'name':'Síria', 'continent':'Ásia','code':'SY'},
	{'name':'Somália', 'continent':'África','code':'SO'},
	{'name':'Sri Lanka', 'continent':'Ásia','code':'LK'},
	{'name':'Suazilândia', 'continent':'África','code':'SWZ'},
	{'name':'Sudão', 'continent':'África','code':'SDN'},
	{'name':'Sudão do Sul', 'continent':'África','code':'SS'},
	{'name':'Suécia', 'continent':'Europa','code':'SWE'},
	{'name':'Suíça', 'continent':'Europa','code':'CH'},
	{'name':'Suriname', 'continent':'América','code':'SR'},
	{'name':'Tailândia', 'continent':'Ásia','code':'TH'},
	{'name':'Taiwan', 'continent':'Ásia','code':'TW'},
	{'name':'Tajiquistão', 'continent':'Ásia','code':'TJ'},
	{'name':'Tanzânia', 'continent':'África','code':'TZ'},
	{'name':'Território Britânico do Oceano Índico', 'continent':'Ásia','code':''},
	{'name':'Territórios Austrais Franceses', 'continent':'Ásia','code':''},
	{'name':'Timor Leste', 'continent':'Ásia','code':''},
	{'name':'Togo', 'continent':'África','code':'TG'},
	{'name':'Tokelau', 'continent':'Oceania','code':''},
	{'name':'Tonga', 'continent':'Oceania','code':''},
	{'name':'Trindade e Tobago', 'continent':'América','code':''},
	{'name':'Tunísia', 'continent':'África','code':'TN'},
	{'name':'Turquemenistão', 'continent':'Ásia','code':'TM'},
	{'name':'Turquia', 'continent':'Ásia','code':'TR'},
	{'name':'Tuvalu', 'continent':'Oceania','code':''},
	{'name':'Ucrânia', 'continent':'Europa','code':'UA'},
	{'name':'Uganda', 'continent':'África','code':'UGA'},
	{'name':'Uruguai', 'continent':'América','code':'UY'},
	{'name':'Uzbequistão', 'continent':'Ásia','code':'UZ'},
	{'name':'Vanuatu', 'continent':'Oceania','code':''},
	{'name':'Vaticano', 'continent':'Europa','code':''},
	{'name':'Venezuela', 'continent':'América','code':'VE'},
	{'name':'Vietnã', 'continent':'Ásia','code':'VN'},
	{'name':'Wallis e Futuna', 'continent':'Oceania','code':''},
	{'name':'Zâmbia', 'continent':'África','code':'ZMB'},
	{'name':'Zimbabué', 'continent':'África','code':'ZW'}
];